import angular from 'angular';
import { AutocompleteComponent } from './autocomplete.component';
import { DropdownItemTemplateComponent } from './dropdown-item-template.component';
export var Autocomplete = angular
    .module('directives.autocomplete', [])
    .component('eeAutocomplete', AutocompleteComponent)
    .component('dropdownItemTemplate', DropdownItemTemplateComponent)
    .name;
//# sourceMappingURL=autocomplete.module.js.map